var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('div',{key:_vm.currentSlotName,staticClass:"transition-wrapper"},[_vm._t(_vm.currentSlotName)],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }